import React, { useEffect, useState } from 'react'
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem } from '@coreui/react'
import { CFormTextarea, CCard, CCardBody, CButton, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CRow, CCol, CFormLabel, CFormInput, CTable, CTableBody, CTableHead, CTableHeaderCell, CTableRow, CTableDataCell, CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react'
import AddMedicationForm from './AddMedicationForm'
import Carder from '../../components/shared/Carder'
import PatientMedications from '../../services/general/patientMedicationData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import moment from 'moment'
import { Medication } from '@mui/icons-material'
import Diagnosis from './Diagnosis'
import pdfToText from 'react-pdftotext'
import MedicineCRUD from '../../services/general/Medication.api'
import { setValue } from '@syncfusion/ej2-base'
import HighlightedText from '../../components/shared/HighlightedText'
import Editor, { Toolbar } from 'react-simple-wysiwyg'

const PatientMedication = ({ patientID, patientName = '', facilityName = '', roomNumber = '', loading, setLoading, saveTreatsShell, medicationList, setMedicationList, noteStructureRef, fetchMedications, showComment, appoinmentDate, noteID }) => {
  const [modalVisible, setModalVisible] = useState(false)
  const [currentDate, setCurrentDate] = useState('')
  const [newMedications, setNewMedications] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  const [editMedicationBundleListDateId, setEditMedicationBundleListDateId] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [medicationOptions, setMedicationOptions] = useState([])

  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  useEffect(() => {
    setCurrentDate(getFormattedDate())
    fetchMedications()
  }, [patientID])

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    const hh = String(today.getHours()).padStart(2, '0')
    const min = String(today.getMinutes()).padStart(2, '0')
    return `${mm}.${dd}.${yyyy} ${hh}:${min}`
  }

  const addMedicationToList = (medication) => {
    const { iseditingList, intervations } = medication
    setNewMedications((prevList) => [...prevList, { ...medication, iseditingList: undefined }])
  }

  const handleSaveMedications = async () => {
    if (newMedications.length === 0) {
      toast.error('Please add some medications', toastConfig)
      return false
    }
    setIsLoading(true)
    try {
      if (editMedicationBundleListDateId) {
        const formattedData = newMedications.map((item) => {
          return {
            id: item.id,
            name: item.name,
            route: item.route,
            dosage: item.dosage,
            frequency: item.frequency,
            Diagnosis: item?.Diagnosis || [],
          }
        })

        await PatientMedications('UPDATE', patientID.toString(), JSON.stringify(formattedData), '', editMedicationBundleListDateId.toString())

        setModalVisible(false)

        setEditMedicationBundleListDateId(null)

        fetchMedications()

        setNewMedications([])

        toast.success('Successfully Updated', toastConfig)
        return true
      } else {
        const formattedData = newMedications.map((item) => {
          return {
            // customId: item.id,
            id: item.id,
            name: item.name,
            route: item.route,
            dosage: item.dosage,
            frequency: item.frequency,
            Diagnosis: item?.Diagnosis || [],
          }
        })
        await PatientMedications('INSERT', patientID.toString(), JSON.stringify(formattedData), getFormattedDate())

        const allMedics = await fetchMedications()

        if (allMedics.length > 0) {
          setNoteMedicationEditId(allMedics[0]?.id)

          noteStructureRef.current = {
            ...noteStructureRef.current,
            metadata: {
              ...noteStructureRef.current.metadata,
              medId: allMedics[0]?.id || '',
            },
          }
          await saveTreatsShell(false)
        }

        setModalVisible(false)

        setNewMedications([])

        toast.success('Successfully Updated', toastConfig)
        await fetchMedications()
        return true
      }
    } catch (error) {
      console.log(error)
      return false
    } finally {
      setIsLoading(false)
    }
  }

  const handleOnCancelAddingFinalMedication = () => {
    setModalVisible(false)
    setNewMedications([])
    setNoteMedicationEditId('')
  }

  const handleFileUpload = (event) => {
    const file = event.target.files[0]
    // Process the file as needed
  }

  const DeletePatientMedication = async (id) => {
    try {
      await PatientMedications('DELETE', patientID.toString(), '', '', deleteVisibleId?.toString())
      await fetchMedications()
      noteStructureRef.current = {
        ...noteStructureRef.current,
        metadata: {
          ...noteStructureRef.current.metadata,
          medId: '',
        },
      }
      await saveTreatsShell(false)
      setDeleteVisibleId(null)
      setNoteMedicationEditId(null)
    } catch (error) {
      console.log(error)
    }
  }

  const editMedicationPatient = (med) => {
    const { medications, id, data } = med
    setEditMedicationBundleListDateId(id)
    setModalVisible(true)
    setNewMedications(data)
  }

  const [noteMedicationEditId, setNoteMedicationEditId] = useState('')

  const handleAddMedication = () => {
    // setNewMedications([])
    const findEditMedNoteId = medicationList.length > 0 && medicationList.find((med) => med.id === noteMedicationEditId)
    if (findEditMedNoteId && noteMedicationEditId) {
      editMedicationPatient(findEditMedNoteId)
    } else {
      setEditMedicationBundleListDateId(null)
      // setNewMedications([])
      setModalVisible(true)
    }
  }

  useEffect(() => {
    const medId = noteStructureRef.current?.metadata?.medId || ''
    setNoteMedicationEditId(medId)
  }, [])

  // useEffect(() => {
  // }, [noteMedicationEditId])

  const [modalComparingFileTextVisible, setModalComparingFileTextVisible] = useState(false)
  const [detectedMedication, setDetectedMedications] = useState([])
  const [textFile, setTextFile] = useState('')

  const extractText = (event) => {
    const input = event.target
    const file = input.files[0]
    if (!file) return

    pdfToText(file)
      .then((text) => {
        if (text !== '') {
          setModalComparingFileTextVisible(true)
          setTextFile(text)
        }
      })
      .catch((error) => {
        console.error('Failed to extract text from PDF', error)
      })
      .finally(() => {
        // Reset input so the same file can be selected again
        input.value = ''
      })
  }

  const [masterMedication, setMasterMedication] = useState([])
  const fetchMasterMedicationsOptions = async () => {
    let allMedicines = await MedicineCRUD('GET')
    let formattedData
    formattedData = JSON.parse(allMedicines.d)?.Data
    formattedData = formattedData.map((item) => {
      return {
        ...item,
        Data: JSON.parse(item.Data),
      }
    })
    if (formattedData) {
      formattedData = formattedData.map((item) => item.Data)
      setMasterMedication(formattedData)
      const allMedications = formattedData.map((item) => ({
        label: `${item.name}`,
        value: `${item.name}`,
      }))
      setMedicationOptions(allMedications)
    }
  }

  useEffect(() => {
    fetchMasterMedicationsOptions()
  }, [])

  useEffect(() => {
    detectMeds()
  }, [textFile])

  const detectMeds = async () => {
    if (textFile) {
      await fetchMasterMedicationsOptions()
      const allDetectedMeds = masterMedication
        .filter((med) => textFile.toLowerCase().includes(med.name?.toLowerCase()))
        .map((med, idx) => ({
          id: Number(`${Date.now()}${idx}`),
          name: med?.name,
          dosage: '',
          route: '',
          intervations: med?.drugIntervention || [],
          frequency: '',
          sideeffect: med?.sideEffect || '',
          diagnosis: med?.diagnoses,
          date: new Date().toLocaleString(),
          standingTemplateName: med?.standingTemplateName,
          iseditingList: undefined,
          Diagnosis: [],
        }))
      setDetectedMedications(allDetectedMeds)
    }
  }

  useEffect(() => {
    detectMeds()
  }, [textFile])

  const handleAddDetectedToMedListInModal = async () => {
    setNewMedications([...newMedications, ...detectedMedication])
    setModalComparingFileTextVisible(false)
    setActiveTab(0)
    setModalVisible(true)
    setDetectedMedications([])
  }

  return (
    <>
      {/* delete modal */}
      <CModal visible={deleteVisibleId}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteVisibleId(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={DeletePatientMedication} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>

      {/* <CNav className="justify-content-center" variant="pills">
        <CNavItem>
          <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
            Manual Entry
          </CNavLink>
        </CNavItem>
        <CNavItem>
          <CNavLink active={activeTab === 1} disabled={noteMedicationEditId} onClick={() => setActiveTab(1)}>
            File Upload
          </CNavLink>
        </CNavItem>
      </CNav> */}
      <CTabContent className="overflow-hidden">
        <CTabPane visible={activeTab === 0}>
          <CButton
            style={{ marginTop: '10px' }}
            onClick={handleAddMedication}
            variant="outline"
            color="primary"
            className="patient-page-action-btn"
          >
            + Add Medications
          </CButton>

          <div>
            <div>
              <hr className="hr-text" data-content="Current Medications" />
              {medicationList.length > 0 &&
                medicationList
                  .filter((med) => noteStructureRef?.current?.metadata?.medId === med.id)
                  .map((medEntry, index) => {
                    return (
                      <Carder
                        deleteFunc={
                          noteMedicationEditId && noteMedicationEditId === medEntry.id
                            ? () => {
                                setDeleteVisibleId(medEntry.id)
                              }
                            : null
                        }
                        editFunc={
                          noteMedicationEditId && noteMedicationEditId === medEntry.id
                            ? () => {
                                editMedicationPatient(medEntry)
                              }
                            : null
                        }
                        className={'mt-4'}
                        title={`Date: 
                                ${new Date(medEntry.date).toLocaleDateString('en-US', {
                                  month: '2-digit',
                                  day: '2-digit',
                                  year: 'numeric',
                                })}
                                `}
                        key={index}
                        style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}
                      >
                        <div className="p-4">
                          <p>
                            Date :{' '}
                            {new Date(medEntry.date).toLocaleDateString('en-US', {
                              month: '2-digit',
                              day: '2-digit',
                              year: 'numeric',
                            })}
                          </p>
                          <CTable className="">
                            <CTableHead>
                              <CTableRow>
                                <CTableHeaderCell>Medication Name</CTableHeaderCell>
                                <CTableHeaderCell>Dosage</CTableHeaderCell>
                                <CTableHeaderCell>Route</CTableHeaderCell>
                                <CTableHeaderCell>Frequency</CTableHeaderCell>
                              </CTableRow>
                            </CTableHead>
                            <CTableBody className="p-0">
                              {medEntry?.data.map((med, medIndex) => {
                                return (
                                  // <CTableRow key={medIndex}>
                                  //     <CTableDataCell>{med.name}</CTableDataCell>
                                  //     <CTableDataCell>{med.dosage}</CTableDataCell>
                                  //     <CTableDataCell>{med.route}</CTableDataCell>
                                  //     <CTableDataCell>{med.frequency}</CTableDataCell>
                                  // </CTableRow>
                                  <CTableRow key={medIndex}>
                                    <CTableDataCell
                                      className={med?.inMaster ? 'text-highlight-orange' : ''}
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'black',
                                      }}
                                    >
                                      {med.name}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      className={med?.inMaster ? 'text-highlight-orange' : ''}
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'black',
                                      }}
                                    >
                                      {med.dosage}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      className={med?.inMaster ? 'text-highlight-orange' : ''}
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'black',
                                      }}
                                    >
                                      {med.route}
                                    </CTableDataCell>
                                    <CTableDataCell
                                      className={med?.inMaster ? 'text-highlight-orange' : ''}
                                      style={{
                                        color: med?.inMaster ? 'orange' : 'black',
                                      }}
                                    >
                                      {med.frequency}
                                    </CTableDataCell>
                                  </CTableRow>
                                )
                              })}
                            </CTableBody>
                          </CTable>
                        </div>
                      </Carder>
                    )
                  })}
              {medicationList.filter((med) => noteStructureRef?.current?.metadata?.medId === med.id).length === 0 && <div className="text-center my-4">No current medications found.</div>}
            </div>
            {/* 
                        <div>
                            <hr className="hr-text" data-content="Old Medications" />
                            {medicationList.length > 0 && medicationList
                            .filter(med => noteStructureRef?.current?.metadata?.medId !== med.id)
                            .map((medEntry, index) => {
                                return (
                                    <Carder
                                        deleteFunc={noteMedicationEditId && noteMedicationEditId === medEntry.id ? () => { setDeleteVisibleId(medEntry.id) } : null}
                                        editFunc={noteMedicationEditId && noteMedicationEditId === medEntry.id ? () => { editMedicationPatient(medEntry) } : null}
                                        className={'mt-4'}
                                        title={`Date: 
                                ${new Date(medEntry.date).toLocaleDateString('en-US', {
                                            month: '2-digit',
                                            day: '2-digit',
                                            year: 'numeric'
                                        })}
                                `} key={index} style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }} >
                                        <div className='p-4'>
                                            <p>Date : {new Date(medEntry.date).toLocaleDateString('en-US', {
                                                month: '2-digit',
                                                day: '2-digit',
                                                year: 'numeric'
                                            })}</p>
                                            <CTable className=''>
                                                <CTableHead>
                                                    <CTableRow>
                                                        <CTableHeaderCell>Medication Name</CTableHeaderCell>
                                                        <CTableHeaderCell>Dosage</CTableHeaderCell>
                                                        <CTableHeaderCell>Route</CTableHeaderCell>
                                                        <CTableHeaderCell>Frequency</CTableHeaderCell>
                                                    </CTableRow>
                                                </CTableHead>
                                                <CTableBody className='p-0'>
                                                    {medEntry?.data.map((med, medIndex) => (
                                                        <CTableRow key={medIndex}>
                                                            <CTableDataCell>{med.name}</CTableDataCell>
                                                            <CTableDataCell>{med.dosage}</CTableDataCell>
                                                            <CTableDataCell>{med.route}</CTableDataCell>
                                                            <CTableDataCell>{med.frequency}</CTableDataCell>
                                                        </CTableRow>
                                                    ))}
                                                </CTableBody>
                                            </CTable>
                                        </div>
                                    </Carder>
                                )
                            })}
                            { medicationList.filter(med => noteStructureRef?.current?.metadata?.medId !== med.id).length === 0 && <div className="text-center my-4">No old medications found.</div>}
                        </div> */}

            {noteStructureRef?.current?.freeTypesEverything?.medHtml && (
              <>
                <hr className="hr-text" data-content="Old Medications" />

                <div className="mt-2">
                  <div
                    className="p-4 patient-theme-old-data patient-theme-old-data--readonly"
                    onClick={() => {
                      // setShowEditHtml(true)
                      setTempHtmlContent(noteStructureRef?.current?.freeTypesEverything?.medHtml)
                    }}
                    dangerouslySetInnerHTML={{ __html: noteStructureRef?.current?.freeTypesEverything?.medHtml }}
                  ></div>
                </div>
              </>
            )}
          </div>
        </CTabPane>
        <CTabPane visible={activeTab === 1}>
          <div style={{}} variant="outline" color="primary" className="d-flex align-items-center gap-2 ">
            <div className="mb-3">
              <CFormInput id="formFileMultiple" label="Multiple files input example" accept="application/pdf" type="file" onChange={extractText} />
            </div>
          </div>
        </CTabPane>
      </CTabContent>

      <AddMedicationForm
        detectMeds={detectMeds}
        handleAddDetectedToMedListInModal={handleAddDetectedToMedListInModal}
        medicationList={medicationList}
        textFile={textFile}
        setTextFile={setTextFile}
        setMedicationList={setMedicationList}
        handleSaveMedications={handleSaveMedications}
        editMedicationBundleListDateId={editMedicationBundleListDateId}
        handleOnCancelAddingFinalMedication={handleOnCancelAddingFinalMedication}
        setEditMedicationBundleListDateId={setEditMedicationBundleListDateId}
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        newMedications={newMedications}
        setNewMedications={setNewMedications}
        addMedicationToList={addMedicationToList}
        patientID={patientID}
        patientName={patientName}
        facilityName={facilityName}
        roomNumber={roomNumber}
        appoinmentDate={appoinmentDate}
        noteID={noteID}
      />

      <CModal
        style={{
          zIndex: 99999999,
        }}
        className="hey"
        backdrop="static"
        size="xl"
        visible={modalComparingFileTextVisible}
      >
        <CModalHeader>
          <CModalTitle>Detected Medications</CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            minHeight: '500px',
            overflowY: 'auto',
          }}
        >
          <div className="d-flex gap-2">
            <div
              className="p-2"
              style={{
                width: '50%',
                overflowY: 'auto',
                borderRadius: '12px',
                border: '1px solid rgb(203, 203, 203)',
                maxHeight: '500px',
                backgroundColor: '#eeeeee',
              }}
            >
              <div className="">
                <HighlightedText text={textFile} keywords={Array.isArray(detectedMedication) ? detectedMedication.map((item) => item.name) : []} />
              </div>
            </div>
            <div
              style={{
                width: '50%',
                overflowY: 'auto',
                borderRadius: '12px',
                maxHeight: '500px',
              }}
            >
              <CAccordion activeItemKey={2}>
                {detectedMedication.map((item, idx) => {
                  return (
                    <CAccordionItem itemKey={idx}>
                      <CAccordionHeader>{item.name}</CAccordionHeader>
                      <CAccordionBody>
                        <div className="d-flex flex-column g w-100">
                          <div className="w-100">
                            <CFormLabel className="mt-3">Dosage</CFormLabel>
                            <CFormInput
                              type="text"
                              value={item.dosage}
                              onChange={(e) => {
                                setDetectedMedications((prev) => {
                                  const updatedData = [...prev]
                                  updatedData[idx].dosage = e.target.value
                                  return updatedData
                                })
                              }}
                            />
                          </div>

                          <div className="w-100">
                            <CFormLabel className="mt-3">Route</CFormLabel>
                            <CFormInput
                              type="text"
                              value={item.route}
                              onChange={(e) => {
                                setDetectedMedications((prev) => {
                                  const updatedData = [...prev]
                                  updatedData[idx].route = e.target.value
                                  return updatedData
                                })
                              }}
                            />
                          </div>

                          <div className="w-100">
                            <CFormLabel className="mt-3">Frequency</CFormLabel>
                            <CFormInput
                              type="text"
                              value={item.frequency}
                              onChange={(e) => {
                                setDetectedMedications((prev) => {
                                  const updatedData = [...prev]
                                  updatedData[idx].frequency = e.target.value
                                  return updatedData
                                })
                              }}
                            />
                          </div>
                        </div>
                      </CAccordionBody>
                    </CAccordionItem>
                  )
                })}
              </CAccordion>
            </div>
          </div>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDetectedMedications([])
              setModalComparingFileTextVisible(false)
              setTextFile('')
            }}
            className=""
            color="secondary"
            variant="outline"
          >
            Close
          </CButton>
          <CButton onClick={handleAddDetectedToMedListInModal} variant="outline" className="" color="primary">
            Add to medication list
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Allergies Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  medHtml: tempHtmlContent,
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
            }}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientMedication
